module.exports = __webpack_public_path__ + "static/media/join-support-program.f5f36a33.png";